<template>
  <div class="car_rent_order">
    <div class="car_rent_order_nav">
      <navbar
        title="租赁申请"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <div class="tabs" v-if="tabs.length">
        <div ref="tabs" class="items">
          <div
            :ref="`tab-${i}`"
            v-for="(tab, i) of tabs"
            :key="i"
            class="item"
            :class="{ active: cateId == tab.id }"
            @click="changeTab(tab)"
          >
            {{ tab.name }}
            <span class="border"></span>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="allOrder">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length != 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell
                class="lists"
                v-for="(item, index) in list"
                :key="index"
              >
                <van-row class="goods" v-if="item.car_order_goods">
                  <van-col span="24" class="goods_info" @click="goDetail(item)">
                    <span
                      class="label"
                      :class="{
                        refund_label: item.status == -10 || item.status == -30,
                      }"
                      >{{ statusLabel[item.status] }}</span
                    >

                    <img :src="item.car_order_goods.images[0]" />
                    <div class="goods_r">
                      <p class="name">{{ item.car_order_goods.goods_name }}</p>
                      <p class="ordersn">订单编号：{{ item.order_num }}</p>
                      <p
                        class="unit_price"
                        :class="{ cancel_num: item.status == -10 }"
                        v-if="
                          item.status == 10 ||
                          item.status == 20 ||
                          item.status == -10 ||
                          item.status == -20
                        "
                      >
                        订金金额：<span>￥</span
                        ><span class="num">{{ item.deposit_amount }}</span>
                      </p>
                      <p
                        class="unit_price"
                        :class="{ cancel_num: item.status == -10 }"
                        v-else
                      >
                        租赁金额：<span>￥</span
                        ><span class="num">{{ item.rent_amount }}</span>
                      </p>
                    </div>
                  </van-col>
                </van-row>
              </van-cell>
            </van-list>
          </van-pull-refresh>
          <van-row class="empty" v-if="list.length == 0 && !hasList">
            <van-col class="emptyMsg" span="24">
              <img src="../../assets/accountAgent/my/no_info.png" />
              <p class="tip">暂无订单</p>
            </van-col>
          </van-row>
          <div class="loading" v-if="list.length <= 0 && hasList">
            <img src="../../assets/accountAgent/common/loading.gif" />
          </div>
        </div>
      </div>
    </div>

    <van-popup class="tipPopup" v-model="tipsShow">
      <p class="title">温馨提示</p>
      <p class="con">合同已签署成功！请2分钟后查看订单</p>
      <btn
        :btntext="'知道了'"
        :btnwidth="'11.4rem'"
        :height="'3.6rem'"
        :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
        :borderradius="'0.6rem'"
        :btncolor="'#fff'"
        :fontsize="'1.4rem'"
        :btnmargin="'0 0 0 6.9rem'"
        @btnClick="knowed"
      />
    </van-popup>
  </div>
</template>
<script>
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      cateId: 0,
      tabs: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "待支付",
        },
        {
          id: 2,
          name: "审核通过",
        },
        {
          id: 3,
          name: "签署完成",
        },
        {
          id: 4,
          name: "已赠送",
        },
        {
          id: 5,
          name: "退款",
        },
      ],
      cateParm: {
        0: [0],
        1: [10],
        2: [30],
        3: [50],
        4: [80],
        5: [-20, -30],
      },
      statusLabel: {
        //10待付订金 20待审核 30审核通过 40合同待签署 -10已取消（未付订金） -20审核驳回
        //50合同已签署 60租赁中 70待财务确认回收 80已完成 -10已取消（未付订金） -20审核驳回(退订中) -30订单关闭
        10: "待支付",
        20: "审核中",
        30: "审核通过",
        40: "合同待签署",
        45: "合同审核中",
        50: "签署完成",
        60: "租赁中",
        70: "租赁中",
        80: "已赠送",
        "-10": "已取消",
        "-20": "退款中",
        "-30": "已退款",
        "-40": "合同已驳回",
      },
      tipsShow: false,
    };
  },
  created() {
    this.getInfo();
    if (sessionStorage.getItem("contractSigned")) {
      this.tipsShow = true;
      sessionStorage.removeItem("contractSigned");
    }
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      if (sessionStorage.getItem("orderBack")) {
        sessionStorage.removeItem("orderBack");
        this.$router.replace("/carRent/carList");
      } else {
        this.$router.go(-1);
      }
    },
    knowed() {
      this.tipsShow = false;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      this.$api
        .post("/onorder/member/car_rental/order/list", {
          page: this.page,
          status: this.cateParm[this.cateId],
        })
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
            this.timeout = true;
          } else {
            this.$toast(message);
          }
        });
    },
    goDetail(item) {
      //10待付订金 20待审核 30审核通过 40合同待签署 -10已取消（未付订金） -20审核驳回
      if (item.status == 30) {
        this.$router.push({
          path: "/carRent/payDetail",
          query: {
            order_num: item.order_num,
            from: "h5",
          },
        });
      } else if (item.status > 30 || item.status == -40) {
        this.$router.push({
          path: "/carRent/payedDetail",
          query: {
            order_num: item.order_num,
            from: "h5",
          },
        });
      } else {
        this.$router.push({
          path: "/carRent/orderDetail",
          query: {
            order_num: item.order_num,
            from: "h5",
          },
        });
      }
    },
    changeTab(item) {
      this.cateId = item.id;
      this.onRefresh();
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.car_rent_order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .car_rent_order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding: 8.8rem 0 0;
    box-sizing: border-box;
    height: 100%;

    .tabs {
      height: 4.4rem;
      line-height: 4.4rem;
      display: flex;
      align-items: center;
      color: #333;
      font-size: 1.4rem;
      font-weight: 700;
      background: #fff;

      .items {
        flex: 1;
        overflow: auto;
        white-space: nowrap;

        &::-webkit-scrollbar {
          display: none;
        }

        .item {
          display: inline-block;
          margin: 0 1.2rem;
          position: relative;

          .border {
            width: 100%;
            height: 0.3rem;
            background: linear-gradient(to right, #49a6ff, #236dfe);
            position: absolute;
            bottom: 0;
            left: 0;
            display: none;
          }

          &.active {
            font-size: 1.4rem;
            color: #236dfe;

            .border {
              display: inline-block;
            }
          }
        }
      }
    }

    .box {
      padding: 1.2rem 1.2rem 0;
      height: calc(100% - 4.4rem);
      box-sizing: border-box;

      .allOrder {
        background-color: #f5f6f7;
        height: 100%;
        box-sizing: border-box;

        .empty {
          padding-top: 10rem;

          .emptyMsg {
            text-align: center;

            img {
              width: 22.1rem;
              display: inline-block;
            }

            .tip {
              color: #cccccc;
              font-size: 1.4rem;
              margin-top: 1.7rem;
              height: 2rem;
              line-height: 2rem;
            }
          }
        }

        .loading {
          width: 100%;
          /*padding-top: 100px;*/
          text-align: center;

          img {
            width: 35%;
            margin-top: 50%;
          }
        }

        .van-pull-refresh {
          height: 100%;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;
          box-sizing: border-box;

          .lists {
            border-radius: 0.8rem;
            padding: 0;
            margin-bottom: 1.2rem;

            .goods {
              height: 11.6rem;
              border-radius: 0.8rem;
              background: #fff;
              padding: 0;

              .goods_info {
                padding: 1.4rem 1.4rem 2.1rem;
                box-sizing: border-box;
                position: relative;

                .label {
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 1;
                  height: 2.4rem;
                  line-height: 2.4rem;
                  padding: 0 1.1rem;
                  color: #fff;
                  font-size: 1.2rem;
                  background: linear-gradient(to right, #49a6ff, #236dfe);
                  border-top-left-radius: 0.6rem;
                  border-bottom-right-radius: 0.6rem;
                }

                .refund_label {
                  color: #666;
                  font-size: 1.2rem;
                  background: #dedede;
                }

                img {
                  position: absolute;
                  top: 1.4rem;
                  left: 1.4rem;
                  width: 10.7rem;
                  height: 8.1rem;
                  border-radius: 0.6rem;
                }

                .goods_r {
                  padding-left: 11.7rem;

                  .name {
                    font-size: 1.6rem;
                    color: #000;
                    font-weight: 700;
                    height: 4.4rem;
                    line-height: 2.2rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    white-space: normal;
                  }

                  .ordersn {
                    color: #999;
                    font-size: 1.2rem;
                    line-height: 1.7rem;
                    margin-top: 0.5rem;
                  }

                  .unit_price {
                    color: #333;
                    font-size: 1rem;
                    line-height: 2.2rem;

                    span {
                      color: #ff4747;
                      font-size: 1rem;
                      font-weight: 700;
                    }

                    .num {
                      font-size: 1.6rem;
                      margin-top: 0.4rem;
                    }
                  }

                  .cancel_num {
                    span {
                      color: #333;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .tipPopup {
    width: 29.6rem;
    border-radius: 0.8rem;
    padding: 3rem 2.2rem 2.2rem;
    box-sizing: border-box;
    color: #333;

    .title {
      font-size: 1.6rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 2rem;
    }

    .con {
      font-size: 1.4rem;
      line-height: 2.5rem;
      margin-bottom: 4.2rem;
    }
  }
}
</style>




